import FormData from 'form-data';
import { useState } from 'react';

import { authSetFile } from '../utils/request';

const useUploadToS3 = () => {
  const [uploading, setUploading] = useState(false);
  const saveFile = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    const data = await authSetFile('/general/uploadToS3', formData, {
      'Content-Type': 'multipart/formdata',
    });
    setUploading(false);
    return data;
  };
  return {
    uploading,
    saveFile
  };
};
export default useUploadToS3;
